import type { MutationKey, QueryKey } from "@tanstack/react-query"
import isNumber from "lodash-es/isNumber"

enum EQueryKeyBase {
    ReflectionInitialData = "ReflectionInitialData",
    ModuleReflectionQuestions = "ModuleReflectionQuestions"
}

const EQueryKey: {
    ReflectionInitialData(): QueryKey
    ModuleReflectionQuestions(params: { moduleId: number; participantId: number }): QueryKey
} = {
    ReflectionInitialData: (): QueryKey => [EQueryKeyBase.ReflectionInitialData],
    ModuleReflectionQuestions: (params: { participantId: number; moduleId?: number }): QueryKey =>
        isNumber(params.moduleId)
            ? [
                  EQueryKeyBase.ModuleReflectionQuestions,
                  `participantId:${params.participantId}`,
                  `moduleId:${params.moduleId}`
              ]
            : [EQueryKeyBase.ModuleReflectionQuestions, `participantId:${params.participantId}`]
} as const

const EQueryUrl: {
    ReflectionInitialData(): string
    ModuleReflectionQuestions(params: { participantId: number; moduleId: number }): string
} = {
    ReflectionInitialData: (): string => "/api/participant/reflection-popup-init-data/",
    ModuleReflectionQuestions: (params: { participantId: number; moduleId: number }): string =>
        `/api/module-reflection/${params.moduleId}/questions/?participant_id=${params.participantId}`
} as const

const EMutationKey: {
    SubmitModuleReflection(params: { participantId: number }): MutationKey
    SkipModuleReflection(params: { sessionId: number }): MutationKey
} = {
    SubmitModuleReflection: (params: { participantId: number }): MutationKey => [
        "SubmitModuleReflection",
        `participantId:${params.participantId}`
    ],
    SkipModuleReflection: (params: { sessionId: number }): MutationKey => [
        "SkipModuleReflection",
        `sessionId:${params.sessionId}`
    ]
} as const

const EMutationUrl: { SubmitModuleReflection(): string; SkipModuleReflection(sessionId: number): string } = {
    SubmitModuleReflection: (): string => "/api/module-reflection/",
    SkipModuleReflection: (sessionId: number): string => `/api/coach-session/skip-post-session-reflection/${sessionId}/`
} as const

export {
    EQueryKeyBase as EPostSessionQueryKeyBase,
    EQueryKey as EPostSessionQueryKey,
    EQueryUrl as EPostSessionQueryUrl,
    EMutationKey as EPostSessionMutationKey,
    EMutationUrl as EPostSessionMutationUrl
}
